module.exports = __webpack_public_path__ + "2472285cd7d7e2edf1a7523f7c3ef72a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/tools.svg
// module id = 786
// module chunks = 0